/**
 * Polling interval for the subscription events polling mechanism for the VeChain provider.
 */
const POLLING_INTERVAL: number = 5000;

export { POLLING_INTERVAL };
